import { Minus, Plus } from 'lucide-react';

import { AccordionContent, AccordionItem, AccordionTrigger } from '@natu/ui/Accordion';
import { Typography } from '@natu/ui/Typography';
import type { PredefinedGAEvents } from '@natu/utils/events';

import { type BlokItem, DynamicRender, type SBProps, sbEditable } from '../../../../utils';

export type SBAccordionItemProps = {
  title?: string;
  body?: BlokItem[];
  disabled?: boolean;
  parentProps?: {
    event?: PredefinedGAEvents;
  };
};

export const SBAccordionItem = ({ blok }: SBProps<SBAccordionItemProps>) => {
  const { body, title, disabled, _uid, parentProps } = blok;

  return (
    <AccordionItem key={_uid} disabled={disabled} value={_uid} {...sbEditable(blok)}>
      <AccordionTrigger
        className="items-start border-b border-gray-200 py-8"
        event={parentProps?.event}
      >
        <Typography
          component="span"
          variant={['text-md', 'text-md', 'text-lg']}
          className="pr-6 text-left font-semibold text-gray-900"
          itemProp="name"
        >
          {title}
        </Typography>
        <Plus className="text-primary-600 size-5 shrink-0 transition-transform duration-200 group-data-[state=open]:hidden" />
        <Minus className="text-primary-600 size-5 shrink-0 transition-transform duration-200 group-data-[state=closed]:hidden" />
      </AccordionTrigger>
      <AccordionContent>
        <div className="pt-8" itemProp="text">
          <DynamicRender data={body} />
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
